import { render, staticRenderFns } from "./PostingModal.vue?vue&type=template&id=b061cfa4&"
import script from "./PostingModal.vue?vue&type=script&lang=ts&"
export * from "./PostingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b061cfa4')) {
      api.createRecord('b061cfa4', component.options)
    } else {
      api.reload('b061cfa4', component.options)
    }
    module.hot.accept("./PostingModal.vue?vue&type=template&id=b061cfa4&", function () {
      api.rerender('b061cfa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingSettlement/PostingModal.vue"
export default component.exports